var constants = require('../constants');


var SetResponse = (function() {

    var _setCurrentResponse = function(data) {
        return function(dispatch, getState) {
            var currentResponse = getState().responses.currentResponse;
            var newCurrentResponse;

            var option = data.option || {};
            delete data.option;

            var dataIndexInCurrentResponse = currentResponse.map(function(x) {
                return x.tag + '_' + x.value;
            }).indexOf(data.tag + '_' + data.value);

            if (option.hasOwnProperty('selected')) {
                if(!option.allowMulti || data.unique){ // single
                    if(option.selected){
                        newCurrentResponse = [data];
                    }else{
                        newCurrentResponse = [];
                    }
                }else{ // multiple
                    if(option.selected){
                        // remove unique choice
                        currentResponse = currentResponse.filter(function(x){
                            return !x.unique;
                        });

                        // upsert
                        if(dataIndexInCurrentResponse > -1){
                            currentResponse[dataIndexInCurrentResponse] = data;
                            newCurrentResponse = currentResponse;
                        }else{
                            newCurrentResponse = currentResponse.concat(data);
                        }
                    }else{
                        newCurrentResponse = currentResponse
                            .slice(0, dataIndexInCurrentResponse)
                            .concat(currentResponse.slice(dataIndexInCurrentResponse + 1));
                    }
                }
            } else if (option.hasOwnProperty('matrix')) {
                if (dataIndexInCurrentResponse > -1) {
                    currentResponse[dataIndexInCurrentResponse] = data;
                    newCurrentResponse = currentResponse;
                } else {
                    newCurrentResponse = currentResponse.concat(data);
                }
            } else {
                newCurrentResponse = [data];
            }

            dispatch(_replaceCurrentResponse(newCurrentResponse));

        };
    }

    var _replaceCurrentResponse = function(data) {
        return {
            type: constants.REPLACE_CURRRENT_RESPONSE,
            data: data
        };
    }

    return {
        setCurrentResponse: _setCurrentResponse
    }
})();

module.exports = SetResponse;



// WEBPACK FOOTER //
// ./src/common/modules/responses/actions/set-current-response.js